import { CircularProgress } from '@mui/material'
import { documentTypeId, relationalDoc, ROUTES } from 'Utils/constants'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { downloadPdfAction } from 'redux/actions/cotizacionActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

const RelationalDocLabel = ({
  value,
  document,
  dataODC,
  'data-testid': dataTestId,
}) => {
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const dispatch = useDispatch()
  const isInvoice = value?.DocumentTypeId === documentTypeId.INVOICE
  const isODC = value?.DocumentTypeId === documentTypeId.ODC
  const isQuotation = value?.DocumentTypeId === documentTypeId.QUOTATION
  const isReturned = value?.DocumentTypeId === documentTypeId.RETURNED

  const name = relationalDoc[value?.DocumentTypeId]?.name
  const basePath = relationalDoc[value?.DocumentTypeId]?.path
  const path = isQuotation
    ? `${value?.DocHeaderId}/${value?.DocumentNumber}`
    : isReturned
    ? value?.DocumentNumber
    : value?.DocHeaderId

  const generateInvoicePDF = async event => {
    if (isInvoice || isODC) {
      const odcHeaderId = document?.QuoteHeaderId ?? document?.DocHeaderId
      event.preventDefault()
      const payload = {
        DocumentTypeId: value?.DocumentTypeId,
        DocHeaderId: isODC ? odcHeaderId : value?.DocHeaderId,
      }

      try {
        setIsLoadingPDF(true)
        if (isInvoice) {
          return dispatch(downloadPdfAction(payload, setIsLoadingPDF))
        }
        if (isODC) {
          const odcItem = dataODC?.find(item => item?.DocumentUrl !== null)
          const url = odcItem?.DocumentUrl
          const isImage = odcItem?.FileType === 'image'

          if (url) {
            if (isImage) {
              window.open(url, '_blank', 'noopener,noreferrer')
            } else {
              try {
                const response = await fetch(url)
                const blob = await response.blob()
                const blobUrl = URL.createObjectURL(
                  new Blob([blob], { type: 'application/pdf' })
                )
                const newTab = window.open(
                  blobUrl,
                  '_blank',
                  'noopener,noreferrer'
                )
                newTab?.addEventListener('unload', () =>
                  URL.revokeObjectURL(blobUrl)
                )
              } catch {
                window.open(url, '_blank', 'noopener,noreferrer')
              }
            }
          }
        }
        setIsLoadingPDF(false)
      } catch (error) {
        console.log('generateInvoicePDF -->', error)
        setIsLoadingPDF(false)
      }
    }
  }

  const element = isInvoice ? (
    <>
      <a
        href={`${ROUTES.invoiceDetail}${value?.DocumentNumber}`}
        target="_blank"
        rel="noreferrer"
        data-testid="link-document">
        {value?.DocumentNumber}
      </a>
      {isLoadingPDF ? (
        <CircularProgress
          size="1rem"
          style={{ marginLeft: 6 }}
          data-testid="loading-pdf"
        />
      ) : (
        <a
          href={`${basePath}${path}`}
          onClick={generateInvoicePDF}
          style={{ marginLeft: 6 }}
          data-testid="link-pdf-document">
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      )}
    </>
  ) : isLoadingPDF ? (
    <CircularProgress
      size="1.5rem"
      style={{ marginLeft: 10 }}
      data-testid="loading-pdf"
    />
  ) : (
    <a
      href={isODC && !dataODC ? null : `${basePath}${path}`}
      target="_blank"
      rel="noreferrer"
      onClick={isODC && !dataODC ? () => null : generateInvoicePDF}
      data-testid="link-document">
      {value?.DocumentNumber}
    </a>
  )

  return (
    <span data-testid={dataTestId}>
      {name}: {element}
    </span>
  )
}

export default RelationalDocLabel
